import { defineComponent as _defineComponent } from 'vue'
import { computed, onBeforeMount, ref } from 'vue';
import { v4 } from 'uuid';


export default /*#__PURE__*/_defineComponent({
  __name: 'CCheckbox',
  props: {
    value: { type: Boolean, default: false },
    id: null,
    label: null,
    switch: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'input', value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: boolean, id?: string, label?: string, switch?: boolean, disabled?: boolean };





const elementId = ref('');

onBeforeMount(() => {
    elementId.value = props.id || `checkbox-${v4()}`;
});

const checked = computed({
    get: () => props.value,
    set: (value: boolean) => emit('input', value)
});

return { __sfc: true,emit, props, elementId, checked }
}

})